import { render, staticRenderFns } from "./TheArticleHeader.vue?vue&type=template&id=37ec4b77&"
import script from "./TheArticleHeader.vue?vue&type=script&lang=js&"
export * from "./TheArticleHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheArticleHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports